export default "__VITE_ASSET__56fab820__"